import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { EuriborModel } from '../../../mortgage/models/euribor.model';
import { MortgageService } from '../../../mortgage/services/mortgage/mortgage.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  euribor: EuriborModel;

  constructor(
    private _mortgageService: MortgageService,
    private datePipe: DatePipe,
    private number: DecimalPipe,
  ) {}

  ngOnInit() {
    this._mortgageService.getEuribor().subscribe((data) => {
      if (data) {
        this.euribor = {
          euribor:
            data && data.euribor !== '-'
              ? this.number.transform(data.euribor, '1.3-3')
              : '-',
          currentMonth:
            data && data.currentMonth !== '-'
              ? this.datePipe.transform(data.currentMonth, 'MMMM yyyy')
              : '-',
          tae: data && data.tae !== '-' ? this.number.transform(data.tae, '1.2-2') : '-',
          differential:
            data && data.differential !== '-'
              ? this.number.transform(data.differential, '1.2-2')
              : '-',
          tinY1:
            data && data.tinY1 !== '-' ? this.number.transform(data.tinY1, '1.2-2') : '-',
          totalLoan:
            data && data.totalLoan !== '-'
              ? this.number.transform(data.totalLoan, '1.2-2')
              : '-',
          totalInterest:
            data && data.totalInterest !== '-'
              ? this.number.transform(data.totalInterest, '1.2-2')
              : '-',
          publicationDate:
            data && data.currentMonth !== '-'
              ? this.datePipe.transform(data.currentMonth, 'dd/MM/yyyy')
              : '-',
          homeInsurance:
            data && data.homeInsurance !== '-'
              ? this.number.transform(data.homeInsurance, '1.2-2')
              : '-',
        };
      }
    });
  }
}
